import React from 'react';

/**
 * The standing note at the top of the Vacation Planner pages: the tool is new,
 * its figures are for planning, and payroll is the word on what is paid. Shown
 * on the list of plans and on the planner itself.
 */
export default function VacationPlannerNotice() {
  return (
    <div className="timeoff-planner-notice" role="note">
      <span className="timeoff-planner-notice__tag">New</span>
      <i className="bi bi-info-circle-fill timeoff-planner-notice__icon" aria-hidden="true" />
      <p className="timeoff-planner-notice__text">
        <strong>The Vacation Planner is a new tool.</strong> Its figures are for planning purposes only and are not
        a direct indication of what payroll will show. Always check your plans with your coach.
      </p>
    </div>
  );
}
